import type AttributeModel from '@netx/core-asset/models/attribute';
import type View from '@netx/core/lib/netx-view';
import {currentUserMeetsUserLevel} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {MINIMUM_USER_LEVEL} from './constants';

export const canManageAttributeProfiles = () =>
	currentUserMeetsUserLevel(MINIMUM_USER_LEVEL);

export const canEdit = (view: View<AttributeModel>) =>
	currentUserMeetsUserLevel(MINIMUM_USER_LEVEL);
